<template>
  <div class="topbar">
    <template v-if="this.$store.state.isLogin">
      <span class="topbar-hello" v-text="'您好，' + this.$store.state.nickName + this.$store.state.deptName + '用户'"></span>
    </template>
    <h1 v-text="this.$store.state.siteName"></h1>
    <login></login>
  </div>
</template>

<script>
import { getInfo } from '@/api/user'
import Login from '@/components/Login.vue'
export default {
  name: 'Topbar',
  data() {
    return {
    }
  },
  props: {
    msg: String
  },
  components: {
    Login
  },
  mounted() {
    if(window.localStorage.getItem('token')){
      this.getInfoData()
    }
  },
  methods: {
    getInfoData() {
      getInfo().then(res => {
        if(res.data.code == 200){
          this.$store.state.nickName = res.data.user.nickName
          this.$store.state.deptName = res.data.user.dept.deptName
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.topbar {
  width: 100%;
  height: 120px;
  background: #ffe7c4;
  font-weight: bold;
  position: relative;
}
.topbar h1 {
  color: #c01509;
  font-size: 36px;
  width: 800px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  position: absolute;
  left: 50%;
  margin-left: -400px;
  top: 0;
}
.topbar-hello {
  position: absolute;
  top: 90px;
  left: 60px;
  font-size: 18px;
  color: #c01509;
  z-index: 1;
}
</style>
